import { KeyboardArrowDown } from '@mui/icons-material';
import {
  SAccordionSummary,
  SAccordion,
  STitle,
  SSubTitle,
  SMuiAccordionDetails,
} from './styled';

export default function Accordion({
  title,
  subtitle,
  children,
  startAdornment,
  endAdornment,
  variant,
  expandIcon,
  className,
  expanded,
  onChange,
  defaultExpanded = false
}) {
  return (
    <SAccordion 
      className={className}
      expanded={expanded}
      onChange={onChange}
      defaultExpanded={defaultExpanded}
    >
      <SAccordionSummary
        className="accordionSummary"
        aria-controls={`panel-${title}-content`}
        expandIcon={
          expandIcon ? expandIcon : <KeyboardArrowDown color="primary" />
        }
      >
        {startAdornment}
        <div>
          <STitle className="accordionTitle">{title}</STitle>
          <SSubTitle className="accordionSubtitle">{subtitle}</SSubTitle>
        </div>
        {endAdornment}
      </SAccordionSummary>
      <SMuiAccordionDetails variant={variant}>{children}</SMuiAccordionDetails>
    </SAccordion>
  );
}
